

import { Component, ViewChild,OnInit, ViewEncapsulation, TemplateRef, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ImageResult } from 'ngx-image2dataurl';
import { ToastrService } from 'ngx-toastr';
import { LocalStorage } from 'ngx-store';
import  *  as  helpData  from  '../../data/help/incidents.json';
import { SignaturePad } from 'angular2-signaturepad';
import * as moment from "moment";
import {DaterangepickerDirective} from 'ngx-daterangepicker-material';
import { saveAs } from 'file-saver';
import { formatDate } from '@angular/common';

//Model
import { Incident, IncidentMobile } from '../../model/incident.model';
import { Ticket } from '../../model/ticket.model';
import { ThemeSetting } from '../../model/users.model';
import { FileExport } from '../../model/exporter.model';
import { Task } from '../../model/tasks.model';
import { Url } from '../../model/users.model';

//Service
import { IncidentsService} from '../../services/incidents.service';
import { FilesService } from '../../services/files.service';
import { TaskService} from '../../services/tasks.service';
import { DataService } from '../../services/data.service';
import { ExportService } from '../../services/exporter.service';

@Component({
    selector: 'app-incidents',
    templateUrl: './incidents.component.html',
    styleUrls: ['../datatable.scss','./incidents.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [IncidentsService, FilesService, TaskService, SignaturePad]
  })
  
  export class IncidentsComponent implements OnInit {
    @LocalStorage() url!: Url;
    @LocalStorage() themeSettings: ThemeSetting;

    public fileStoragePath = this.url.fileStorage;

    rows = [];
    incident_rows = []
    jobs = [];
    selected = [];
    selected2 = [];
    loadingIndicator: boolean = true;
    reorderable: boolean = true;

    drivers = [];
    fleet = [];
    incident_statuses = [];
    incident_types = [];
    ratings = [];
    ticket_statuses = [];

    public incidentForm: FormGroup; 
    public incidentFormMobile: FormGroup; 
    public ticketForm: FormGroup;
    public modalRef: NgbModalRef;


    public incident: Incident;
    public incidentMobile: IncidentMobile;
    public ticket: Ticket;
    public isEditMode: boolean = false;

    //Meridian
    public timeMeridian = { hour: 15, minute: 20};
    public meridian: boolean = true;

    public readonly prefixTicket = 'tickets';
    public readonly prefixIncident = 'incident';

    public frmFile: any;
    public fileExists :boolean;
    public fileRemove :boolean;
    public oldFile: string;

    public tasksByIncidentId: Task[];
    public task: Task;
    public incidentId: number;
    public trafficTicketId: number;
    public tasksByTrafficTicketId: Task[];

    public caller : string ='';
    public modalCaller: string;

    loading_indicator1 : boolean= true;
    loading_indicator2 : boolean= true;

    help:any;

    showIncidentDate:boolean=true;
    showIncidentTime:boolean=true;
    showIncidentDriver:boolean=true;
    showIncidentStatus:boolean=true;
    showIncidentFile:boolean=true;

    showTicketDate:boolean=true;
    showTicketTime:boolean=true;
    showTicketDriver:boolean=true;
    showTicketStatus:boolean=true;
    showTicketFile:boolean=true;

    myDropDown='7';
    dateFilter='Last 7 Days';

    myDropDown1='7';

    public incidentDateRange: any =[];
    public ticketDateRange: any =[];
    locale: any = {
      format: 'DD MMMM YYYY',
      displayFormat: 'DD MMMM YYYY',
      separator: ' to ',
      cancelLabel: 'Cancel',
      applyLabel: 'OK',
    }
    maxDate: moment.Moment = moment();
    totalTicketAmount: any;
    totalTicket: number = 0;
    averageTicketAmount: any;
    
    @Input() driver_id: number;
    
    @ViewChild('modalTicket', {static: false}) modalTicket: TemplateRef<any>;
    @ViewChild('modalIncident', { static: false }) modalIncident: TemplateRef<any>;
    @ViewChild('modalIncidentMobile', { static: false }) modalIncidentMobile: TemplateRef<any>;
    @ViewChild('modalDeleteTicket', { static: false }) modalDeleteTicket: TemplateRef<any>;
    @ViewChild('modalDeleteIncident', { static: false }) modalDeleteIncident: TemplateRef<any>;
    @ViewChild(DaterangepickerDirective, {static: false}) daterangepicker: DaterangepickerDirective;
    @ViewChild(SignaturePad, {static: false}) signaturePad: SignaturePad;
    public signaturePadOptions: Object = { // passed through to szimek/signature_pad constructor
      'minWidth': 1,
      'canvasWidth': 750,
      'canvasHeight': 200,
      'penColor': '#0000AF'
  
    };
  Date: any;
  dd2: any;
  dd3: any;
  domain: any;
  fullname: any;
  signatureImage: any;
  lat: any;
  lng: any;
  loc_date: any;
  address: any;
  map_string: any;
  time: any;
  public imageFiles : any[];

  //Handles the name, type and content of the to-be exported file
  public exp_excel: FileExport;
  public exp_pdf: FileExport;
 
  //Stores the filtered and formatted content of the file
  formatted_list : any;
  spinner: boolean = false;

  status_id:any;
  tp:any;
  ip:any;

  type_opt= [
    {
      id: 1,
      name: 'dd2',
      desc: 'It is a near miss'
    },
    {
      id: 2,
      name: 'dd3',
      desc: 'It is an accident'
    }
  ]


  dateNow:any;

  
    constructor(private http: HttpClient, private _fb: FormBuilder, private modal: NgbModal, private incidentsService: IncidentsService,
                private fileService: FilesService, private taskService: TaskService, private toastr: ToastrService,private data: DataService,
                private exporter: ExportService){
    }
    ngOnInit() {
      this.dateNow = new Date().toLocaleString();
      this.initIncidentForm();
      this.initIncidentFormMobile();
      this.initTicketForm();

      this.getIncidentPageData();
      this.getTicketStatuses();

      this.resetFileVariables();
      if(!this.driver_id){
        this.data.currentHelp.subscribe(help => this.help = help);
      }
      
      //Declaration to handle the name, type and content of the file
      this.exp_excel = {title:'', list_data:'', type:''};
      this.exp_pdf = {title:'', list_data:'', type:''};
    }

    ngAfterViewInit() {
      this.signaturePad.set('minWidth', 1); // set szimek/signature_pad options at runtime
      this.signaturePad.clear(); // invoke functions from szimek/signature_pad API
      if(!this.driver_id){
        setTimeout(() => { 	this.data.changeHelp(helpData["default"]);  });
      }
    }
  

    ticket_columns = [
      { prop: 'id' },
      { prop: 'date' },
      { prop: 'time' },
      { prop: 'fleet_id' },
      { prop: 'driver_id' },
      { prop: 'cost' },
      { prop: 'location' },
      { prop: 'violation' },
      { prop: 'demerits' },
      { prop: 'receipt_no' },
      { prop: 'note' },
      { prop: 'file' },
      { prop: 'status_id' },
      { prop: 'driver' },
      { prop: 'rego' },
      { prop: 'status' },
      { prop: 'ticketTaskCount' },


    ];

    incident_columns = [
      { prop: 'id' },
      { prop: 'date_added' },
      { prop: 'time_added' },
      { prop: 'status_id' },
      { prop: 'question_id' },
      { prop: 'rating_id' },
      { prop: 'description' },
      { prop: 'location' },
      { prop: 'witness' },
      { prop: 'notification' },
      { prop: 'type_id' },
      { prop: 'driver_id' },
      { prop: 'fleet_id' },
      { prop: 'filename' },
     
      { prop: 'driver' }, 
      { prop: 'rego' },
      { prop: 'type' },
      { prop: 'rating' },
      { prop: 'status' },
      { prop: 'incidentTaskCount' },

    ];

    initTicketForm() {
      const currencyRegex = '^[0-9]{1,3}(?:,?[0-9]{3})*(?:\.[0-9]{2})?$';
      const numbers = '^[0-9]+$'; 
    
      this.ticketForm = this._fb.group({
        id:          [''],
        fleet_id:    ['', Validators.required],
        driver_no:   ['', Validators.required],
        location:    ['', Validators.required],
        violation:   ['', Validators.required],
        cost:        ['', [Validators.required, Validators.pattern(currencyRegex)]],
        date:        ['', Validators.required],
        time_string: [{hour: 1, minute: 30}, Validators.required],
        demerits:    ['' , [Validators.required, Validators.pattern(numbers)]],
        receipt_no:  ['', Validators.required],
        note:        [''],
        file:        [''],
        status_id:   ['', Validators.required],
        time_added:  [''],
        driver:      [''],
        rego:        [''],
        status:      ['']
      });
    }

    initIncidentForm() {
      this.incidentForm = this._fb.group({
        id: [''],
        fleet_id: ['', Validators.required],
        driver_id: ['', Validators.required],
        driver_signature: [''],
        type_id: ['', Validators.required],
        status_id: ['', Validators.required],
        question_id: [''],
        description: ['', Validators.required],
        rating_id: ['' , Validators.required],    
        location: ['', Validators.required],
        witness: ['', Validators.required],
        notification: [''],
        date_added: ['', Validators.required],
        time:[''],
        time_string: [{hour: 1, minute: 30}, Validators.required],
        filename: [''],
        driver: [''],
        rego: [''],
        type: [''],
        rating: [''],
        status: ['']
      });
    }
    initIncidentFormMobile() {
      this.incidentFormMobile = this._fb.group({
        date_added: ['', Validators.required],
        dd2: [''],
        dd3: [''],
        demerits: [''],
        domain: JSON.parse(localStorage.getItem('ngx_url')).rest,
        driver_id: ['', Validators.required],
        driver_name: [''],
        driver_signature: [''],
        fine: [''],
        file1: ['', Validators.required],
        file2: [''],
        file3: [''],
        file4: [''],
        file5: [''],
        file6: [''],
        file7: [''],
        file8: [''],
        file9: [''],
        file10: [''],
        fileCount: [''],
        fleet_id: ['', Validators.required],
        incident: ['', Validators.required],
        lat: '',
        lng: '',
        loc_date: [''],
        location: [''],
        map: [''],
        isSigned: [''],
        note: '',
        notification: ['', Validators.required],
        time_added: [{hour: 1, minute: 30}, Validators.required],
        timeadded2: [''],
        type_opt: [''],
        violation: [''],
        witness: ['', Validators.compose([
          Validators.required
        ])],
      });
    }
   
    isCost() {
      const frmCtrl = (<any>this.ticketForm);
  
      if (frmCtrl.controls.cost.valid)
        return true;
      else return false;
    }
    onSelect({ selected }) {
      console.log('Select Event', selected, this.selected);
      this.getTasksByTrafficTicketId();
    }
  
    onActivate(event) {
      console.log('Activate Event', event);
    }

    onSelect2({ selected2 }) {
      console.log('Select Event2', selected2, this.selected2);
      this.getTasksByIncidentId();
    }
  
    onActivate2(event) {
      console.log('Activate Event2', event);
    }

    getTickets(myDropdown,start='', end='') {
      if(this.driver_id){
        this.incidentsService.getTicketsByDriverId(this.driver_id,myDropdown,start,end).subscribe(data => {
         
          this.rows = data["tickets"];
            this.fullRowsTickets = this.rows;
            this.tempTickets = this.rows;
              if(this.rows.length>0 && this.rows != null){
              this.selected = [this.rows[0]];
              this.ticketCount = Object.keys(this.rows).length;

              }
              else{
                this.rows = []
                this.selected=[];
              }
            this.computeTicketSubtotals();
            this.getTasksByTrafficTicketId();
  
  
          setTimeout(() => { this.loading_indicator1 = false; }, 1500);
        });
      }else{
        this.incidentsService.getTickets(myDropdown,start, end).subscribe(data => {
            this.rows = data["tickets"];
            this.fullRowsTickets = this.rows;
            this.tempTickets = this.rows;
              if(this.rows.length>0 && this.rows != null){
              this.selected = [this.rows[0]];
              this.ticketCount = Object.keys(this.rows).length;

              }
              else{
                this.rows = []
                this.selected=[];
              }
            this.computeTicketSubtotals();
            this.getTasksByTrafficTicketId();
  
  
          setTimeout(() => { this.loading_indicator1 = false; }, 1500);
        });
      }
      
    }

    onChangeofOptions1(selected) {
      console.log('changing to');
      if (selected == 'week') {
          this.myDropDown1 =  'week'
          this.dateFilter = 'This Week'
          this.showFilters = false;
          this.getTickets(this.myDropDown1);
      }
      else
      if (selected == 'month') {
          this.myDropDown1 =  'month'
          this.dateFilter = 'Month'
          this.showFilters = false;
          this.getTickets(this.myDropDown1);
      }
      else 
      if (selected == 'years') {
          this.myDropDown1 =  'years'
          this.dateFilter = 'This Year'
          this.showFilters = false;
          this.getTickets(this.myDropDown1);
      }
      else
      if (selected == 'today') {
          this.myDropDown1 =  'today'
          this.dateFilter = 'Today'
          this.showFilters = false;
          this.getTickets(this.myDropDown1);
      }
      else
      if (selected == '7') {
          this.myDropDown1 =  '7'
          this.dateFilter = 'Last 7 Days'
          this.showFilters = false;
          this.getTickets(this.myDropDown1);
      }
      else
      if (selected == '14') {
          this.myDropDown1 =  '14'
          this.dateFilter = 'Last 14 Days'
          this.showFilters = false;
          this.getTickets(this.myDropDown1);
      }
      else
      if (selected == '30') {
          this.myDropDown1 =  '30'
          this.dateFilter='Last 30 Days'
          this.showFilters = false;
          this.getTickets(this.myDropDown1);
      }
      else
      if (selected == '90') {
          this.myDropDown1 =  '90'
          this.dateFilter = 'Last 90 Days'
          this.showFilters = false;
          this.getTickets(this.myDropDown1);
      }
      else
      if (selected == 'range') {
          this.myDropDown1 =  'range'
          this.dateFilter = 'range'
          this.showFilters = true;
          // this.getTickets(this.myDropDown1);
          this.processTicketDateRange();
      }
  }

  processTicketDateRange() {
    var start = moment(this.ticketDateRange.start?._d).format('YYYY-MM-DD');
    var end = moment(this.ticketDateRange.end?._d).format('YYYY-MM-DD');
    console.log(start + ' to ' + end);
    this.getTickets('range',start, end);
  }

  computeTicketSubtotals() {
    this.totalTicketAmount = 0;
    this.totalTicket = 0;
    if (this.rows[0]) {
        let sum: number = this.rows.map(a => a.cost).reduce(function(a, b)
        {
        return a + b;
        });
        this.totalTicketAmount = sum;

        this.totalTicket = this.rows.length;
    }
    this.averageTicketAmount = (this.totalTicketAmount / this.totalTicket) || 0;
}

    getTicketStatuses(){
      this.incidentsService.getTicketStatuses().subscribe(data => {
        this.ticket_statuses = data["ticket_statuses"];
      })
    }

    public createTicket(ticket: Ticket) {
      this.spinner = true;
      this.incidentsService.createTicket(ticket).subscribe(() => {
      this.getTickets(this.myDropDown1);   
      });
      this.spinner = false;
    }

    async updateTicket(ticket: Ticket) {
      this.spinner = true;
      await this.incidentsService.updateTicket(ticket).toPromise().then(result => {
        this.toastr.success('', result['message'], {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
         
      }).catch(() =>{
        this.toastr.error("Please try again.", "There was a problem with updating the selected ticket.", {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }).finally(() => {
        this.getTickets(this.myDropDown1);
      });
      this.spinner = false;
    }

    async deleteTicket(ticket: Ticket) {
      this.spinner = true;
      if(ticket.file != null && ticket.file != ''){
      this.deleteFile(this.prefixIncident, ticket.file);
      }

      await this.incidentsService.deleteTicket(ticket.id).toPromise().then(result => {
        this.toastr.success('', result['message'], {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }).catch(() =>{
        this.toastr.error("Please try again.", "There was a problem with deleting the selected ticket.", {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }).finally(() => {
        this.getTickets(this.myDropDown1);
      });
     
      this.modalRef.close();   
      this.spinner = false;    
    }


    getIncidentPageData()  {
      if(this.driver_id){
        this.getIncidents(this.myDropDown);
        this.getTickets(this.myDropDown1);
        
        this.incidentsService.getIncidentPageDataMisc().subscribe(data => {
          this.drivers = data["drivers"];
          this.fleet = data['fleet'];
          this.incident_statuses = data['incident_statuses'];
          this.incident_types = data['incident_types'];
          this.ratings = data['ratings'];
        });
  
      }else{
        this.incidentsService.getIncidentPageData().subscribe(data => {
          this.getIncidents(this.myDropDown);
          this.getTickets(this.myDropDown1);
  
          this.drivers = data["drivers"];
          this.fleet = data['fleet'];
          this.incident_statuses = data['incident_statuses'];
          this.incident_types = data['incident_types'];
          this.ratings = data['ratings'];
  
          this.fullRowsTickets = this.rows;
          this.tempTickets = this.rows;
          this.ticketCount = Object.keys(this.rows).length;
  
          this.getTasksByIncidentId();
          this.getTasksByTrafficTicketId();
          setTimeout(() => { this.loading_indicator2 = false; this.loading_indicator1 =false }, 1500);
          });
      }
    }

    getIncidents(myDropdown,start='', end='') {

      if(this.driver_id){
        this.incidentsService.getIncidentsByDriverId(this.driver_id,myDropdown,start,end).subscribe(data => {
          this.incident_rows = data['incidents'];
          this.fullRowsIncidents = this.incident_rows;
          this.tempIncidents =  this.incident_rows;
          if(this.incident_rows.length>0 && this.incident_rows != null){
          this.selected2 = [this.incident_rows[0]];
          this.incidentCount = Object.keys(this.incident_rows).length;
          }
          else{
            this.incident_rows = []
            this.selected2=[];
          }
          this.getTasksByIncidentId();

          setTimeout(() => { this.loading_indicator2 = false; }, 1500);
        });
      }else{
        this.incidentsService.getIncidents(myDropdown,start, end).subscribe(data => {
         
              this.incident_rows = data['incidents'];
              this.fullRowsIncidents = this.incident_rows;
              this.tempIncidents =  this.incident_rows;
              if(this.incident_rows.length>0 && this.incident_rows != null){
              this.selected2 = [this.incident_rows[0]];
              this.incidentCount = Object.keys(this.incident_rows).length;
              }
              else{
                this.incident_rows = []
                this.selected2=[];
              }
              this.getTasksByIncidentId();

              setTimeout(() => { this.loading_indicator2 = false; }, 1500);
        });
      }
    }

    onChangeofOptions(selected) {
      if (selected == 'week') {
          this.myDropDown =  'week'
          this.dateFilter = 'This Week'
          this.showFilters = false;
          this.getIncidents(this.myDropDown);
      }
      else
      if (selected == 'month') {
          this.myDropDown =  'month'
          this.dateFilter = 'Month'
          this.showFilters = false;
          this.getIncidents(this.myDropDown);
      }
      else 
      if (selected == 'years') {
          this.myDropDown =  'years'
          this.dateFilter = 'This Year'
          this.showFilters = false;
          this.getIncidents(this.myDropDown);
      }
      else
      if (selected == 'today') {
          this.myDropDown =  'today'
          this.dateFilter = 'Today'
          this.showFilters = false;
          this.getIncidents(this.myDropDown);
      }
      else
      if (selected == '7') {
          this.myDropDown =  '7'
          this.dateFilter = 'Last 7 Days'
          this.showFilters = false;
          this.getIncidents(this.myDropDown);
      }
      else
      if (selected == '14') {
          this.myDropDown =  '14'
          this.dateFilter = 'Last 14 Days'
          this.showFilters = false;
          this.getIncidents(this.myDropDown);
      }
      else
      if (selected == '30') {
          this.myDropDown =  '30'
          this.dateFilter='Last 30 Days'
          this.showFilters = false;
          this.getIncidents(this.myDropDown);
      }
      else
      if (selected == '90') {
          this.myDropDown =  '90'
          this.dateFilter = 'Last 90 Days'
          this.showFilters = false;
          this.getIncidents(this.myDropDown);
      }
      else
      if (selected == 'range') {
          this.myDropDown =  'range'
          this.dateFilter = 'range'
          this.showFilters = true;
          // this.getIncidents(this.myDropDown);
          this.processIncidentDateRange('');
      }
  }

  processIncidentDateRange(event) {
    console.log('processing range');
    var start = moment(this.incidentDateRange.start?._d).format('YYYY-MM-DD');
    var end = moment(this.incidentDateRange.end?._d).format('YYYY-MM-DD');
    console.log(start + ' to ' + end);
    this.getIncidents('range',start, end);
  }

    async createIncident(incident: Incident) {
      this.spinner = true;
      await this.incidentsService.createIncident(incident).toPromise().then(result => {
        this.toastr.success('', result['message'], {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      
           
      }).catch(() =>{
        this.toastr.error("Please try again.", "There was a problem with creating new incident entry.", {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }).finally(() => {
        this.getIncidents(this.myDropDown);
      });
      this.spinner = false;
    }

    async updateIncident(incident: Incident) {
      this.spinner = true;
      await this.incidentsService.updateIncident(incident).toPromise().then(result => {
        this.toastr.success('', result['message'], {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });  
      }).catch(() =>{
        this.toastr.error("Please try again.", "There was a problem with updating the selected incident. ", {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }).finally(() => {
        this.getIncidents(this.myDropDown);
      });
      this.spinner = false;
    }

    async deleteIncident(incident: Incident) {
      this.spinner = true;
      if(incident.filename != null && incident.filename != ''){
      this.deleteFile(this.prefixIncident, incident.filename);
      }

      await this.incidentsService.deleteIncident(incident.id).toPromise().then(result => {
        this.toastr.success('', result['message'], {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });    
      }).catch(() =>{
        this.toastr.error("Please try again.", "There was a problem with deleting the selected incident.", {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }).finally(() => {
        this.getIncidents(this.myDropDown);
      });
      
      this.modalRef.close();   
      this.spinner = false;    
    }

    openTicketModal(ticket: Ticket): void { 
        if(ticket){
          this.isEditMode = true;
          this.ticket = ticket;
          this.ticket['time_string'] = {hour: this.ticket['hour'], minute: this.ticket['minute']};
          this.ticketForm.patchValue(this.ticket);

          if (this.ticket.file != null && this.ticket.file != '')
          {
            this.oldFile = this.ticket.file;
            this.fileExists = true;
          }
        } 
        else{
          this.isEditMode = false;
          this.ticket = new Ticket();
          this.ticketForm.reset();

          //if caller is driverdetails
          if(this.driver_id){
            this.ticketForm.controls.driver_no.setValue(this.driver_id);
          };
    
          
        }   
        this.modalRef = this.modal.open(this.modalTicket, { size: 'lg', backdrop: 'static'});
      
        this.modalRef.result.then(() => {
          this.ticketForm.reset();
        }, () => {
          this.ticketForm.reset();
        });
    }

    openDeleteTicketModal(ticket: Ticket): void {
        
      if(ticket){
        this.ticket = ticket;
      } 
      this.modalRef = this.modal.open(this.modalDeleteTicket, { size: 'sm', backdrop: 'static'});
    }   

    openIncidentModal(incident: Incident): void {

      if(incident){


        this.isEditMode = true;
        this.incident = incident;
        this.incident['time_string'] = {hour: this.incident['hour'], minute: this.incident['minute']};  
              
        this.incidentForm.patchValue(this.incident);

         if (this.incident.filename != null && this.incident.filename != '')
        {
          this.oldFile = this.incident.filename;
          this.fileExists = true;
        }
        

       } 
      else{
        this.isEditMode = false;
        this.incident = new Incident();
        this.incidentForm.reset();

         //if caller is driverdetails
         if(this.driver_id){
          this.incidentForm.controls.driver_id.setValue(this.driver_id);
        };
      }   
      this.modalRef = this.modal.open(this.modalIncident, { size: 'lg', backdrop: 'static'});
    
      this.modalRef.result.then(() => {
        this.incidentForm.reset();
      }, () => {
        this.incidentForm.reset();
      });
    }
    openIncidentModalMobile(incident: IncidentMobile): void {

      if(incident){
        this.isEditMode = true;
        this.incidentMobile = incident;  
        this.incidentFormMobile.patchValue(this.incidentMobile);

       } 
      else{
        this.isEditMode = false;
        this.incidentMobile = new IncidentMobile();
        this.incidentFormMobile.reset();

         //if caller is driverdetails
         if(this.driver_id){
          this.incidentFormMobile.controls.driver_id.setValue(this.driver_id);
        };
      }   
      this.modalRef = this.modal.open(this.modalIncidentMobile, { size: 'lg', backdrop: 'static'});
    
      this.modalRef.result.then(() => {
        this.incidentFormMobile.reset();
      }, () => {
        this.incidentFormMobile.reset();
      });
    }

    openDeleteIncidentModal(incident: Incident): void {
          
      if(incident){
        this.incident = incident;
      } 
      this.modalRef = this.modal.open(this.modalDeleteIncident, { size: 'sm', backdrop: 'static'});
    }   


    async onSubmitTicket(ticket: Ticket) {
      this.spinner = true;
      this.ticket = ticket;
      this.ticket['time'] = this.ticket['time_string'].hour + ":" + this.ticket['time_string'].minute + ":00";


      if (this.ticketForm.valid) {
        this.ticket = ticket;
        
        if(ticket.id){

          this.updateTicket(this.ticket);
        }
        else{
          
          await this.incidentsService.createTicket(ticket).subscribe(result=> {
            this.toastr.success('', result['message'], {
              timeOut: 5000,
              positionClass: 'toast-top-full-width',
              progressBar: true
            }); 
            this.getTickets(this.myDropDown1);   
          }, ()=>{
            this.toastr.error("Please try again.", "There was a problem with creating new ticket entry.", {
              timeOut: 5000,
              positionClass: 'toast-top-full-width',
              progressBar: true
            });
          });
        }   

        this.uploadFile(this.prefixTicket, this.ticket.file);
        this.modalRef.close();    
        this.spinner = false;
      }
    }

    async onSubmitIncident(incident: Incident) {
      this.spinner = true;
      this.incident = incident;
      this.incident['time_added'] = this.incident['time_string'].hour + ":" + this.incident['time_string'].minute + ":00";

      if (this.incidentForm.valid) {
        this.incident = incident;
        
        if(incident.id){
          this.updateIncident(this.incident);
          console.log('updating incident...');
        }
        else{
        
          await this.incidentsService.createIncident(incident).toPromise().then(result => {
            this.toastr.success('', result['message'], {
              timeOut: 5000,
              positionClass: 'toast-top-full-width',
              progressBar: true
            });
              
          }).catch(() =>{
            this.toastr.error("Please try again.", "There was a problem with creating new incident entry.", {
              timeOut: 5000,
              positionClass: 'toast-top-full-width',
              progressBar: true
            });
          }).finally(() => {
            this.getIncidents(this.myDropDown); 
          });
          this.spinner = false;
        }   

        this.uploadFile(this.prefixIncident, this.incident.filename);

        this.modalRef.close();    

      }
    }
    async onSubmitIncidentMobile(incident: IncidentMobile) {
      this.spinner = true;
      this.incidentMobile = incident;
      if (this.signatureImage !== null) {
        this.drivers.forEach(data => {
          if (data.id === +this.incidentMobile['driver_id']) {
            this.incidentMobile['driver_name'] = data.first_name + ' ' + data.last_name;
          }
        });
        this.incidentMobile['loc_date'] = this.incidentMobile['date_added'];
        this.incidentMobile['map'] = this.incidentMobile['location'];
        this.incidentMobile['driver_signature'] = this.signatureImage;
        this.incidentMobile['isSigned'] = true;
      } else {
        this.incidentMobile['isSigned'] = false;
      }
      this.incidentMobile['time_added'] = this.incidentMobile['time_added'].hour + ":" + this.incidentMobile['time_added'].minute + ":00";

      if(this.incidentMobile['type_opt'] == 'dd2'){
        this.incidentMobile.dd2 = true;
        this.incidentMobile.dd3 = false;
      }
      else {
        this.incidentMobile.dd2 = false;
        this.incidentMobile.dd3 = true;
      }
      
      if (this.incidentFormMobile.valid) {
        this.incidentMobile = incident;
          await this.incidentsService.createIncidentMobile(this.incidentMobile).toPromise().then(result => {
            this.toastr.success('', result['message'], {
              timeOut: 5000,
              positionClass: 'toast-top-full-width',
              progressBar: true
            });
              
          }).catch(() =>{
            this.toastr.error("Please try again.", "There was a problem with creating new incident entry.", {
              timeOut: 5000,
              positionClass: 'toast-top-full-width',
              progressBar: true
            });
          }).finally(() => {
            this.getIncidents(this.myDropDown); 
          });
        this.signatureImage = null;
        this.modalRef.close();    
        this.spinner = false;
      }
    }
    drawStart(): void {
      console.log('Begin Drawing');
    }
  
    drawComplete1(data): void {
      this.signatureImage = data.toDataURL();
      console.log(this.signatureImage);
    }
    ClearDraw() {
      // will be notified of szimek/signature_pad's onEnd event
      this.signaturePad.clear();
      this.signatureImage = null;
    }


    print(elementId: string): void {
      let printContents, popupWin;
      printContents = document.getElementById(elementId).innerHTML;
      popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
      popupWin.document.open();
      popupWin.document.write(`
        <html>
        <head>
        <title>Incidents</title>
        <style>
        @page {
          size: A4;
        }

        table {
          border-collapse: collapse;
          border-spacing: 0;
          width: 100%;
          border: 1px solid #ddd !important;
      }

      th, td {
          text-align: left;
          padding: 16px;
      }


      tr:nth-child(even) {
          background-color: #f2f2f2 !important;
          box-shadow: inset 0 0 0 1000px #f2f2f2;
      }

      .fn {
        float: footnote;
      }

      thead {
        box-shadow: inset 0 0 0 1000px #f2f2f2;
      }
        
          
      </style>
      </head>
      <body onload="window.print();window.close()">${printContents}</body>
        </html>`
      );
      popupWin.document.close();
    }

    public formatDate(inDate: string) {
      let formatedDate: Date;
      if (inDate && !inDate.includes('0000') ) {
        formatedDate = new Date(inDate.replace(/-/g, "/"));
        return formatedDate;
      }
      else return null;
    }


    public getFile(event, caller){

      var imgFilename;

      if (event == '' || event == null){
        imgFilename = event
        //this.frmDoc.controls.file.setValue(event);
      }else{
        var file : ImageResult;
        file = event;
        imgFilename =  file.file.name;

        this.frmFile = event;
      }

      switch (caller){
        case this.prefixTicket: 
          { this.ticketForm.controls.file.setValue(imgFilename); break;};
        case this.prefixIncident: 
          { this.incidentForm.controls.filename.setValue(imgFilename); break;};
        default: break;
      }
    }

    public uploadFile(caller, filename){
      if (this.frmFile){
        this.fileService.uploadRawFile(caller, this.frmFile, filename).subscribe(()=>{
          console.log('file uploaded....');
        });
        
      }

      this.frmFile = '';

      //handling files if replaced, old file is removed from server
        if(this.fileRemove == true){
            this.deleteFile(caller, this.oldFile);
        };
    }

    public deleteFile(caller, filename){
      this.fileService.deleteFile(caller, filename).subscribe(result=>{console.log(result);})
        this.fileRemove = false;
    }

    public resetFileVariables(){
       // for document file handling variables; checking if file exists or removed
          this.fileExists = false;
          this.fileRemove  = false;
          this.oldFile = '';
    }

    public removeFile(caller){
      this.fileExists  = false;

      switch (caller){
      case  this.prefixIncident:
        { this.incidentForm.controls.filename.setValue(''); break;};
      case this.prefixTicket:
        { this.ticketForm.controls.file.setValue(''); break;};
      default: break;
      }
      
      this.fileRemove = true;
  }

  showFilters: boolean = false;
  
  filterIncidentDriver: string = '';
  filterIncidentType: string = '';
  filterIncidentDateFrom: Date;
  filterIncidentDateTo: Date;

  filterTicketDriver: string = '';
  filterTicketViolation: string = '';
  filterTicketDateFrom: Date;
  filterTicketDateTo: Date;
  
  isFilterEmpty: boolean = true;
  tempTickets = [];
  tempIncidents = [];
 
  fullRowsTickets = [];s
  fullRowsIncidents = [];
  
  ticketCount = 0;
  incidentCount = 0;
  
  public toggleFilters() {
    if (this.showFilters) this.showFilters = false;
    else this.showFilters = true;
  }

  updateFilter(caller) {
    this.isFilterEmpty = false;

    switch (caller){

      case this.prefixTicket :{

        this.tempTickets = this.fullRowsTickets.filter(data => {
         if (this.filterTicketDriver && data.driver_no){
            return data.driver_no == this.filterTicketDriver;    
          }else{
            return data.driver_no;
          }
        });

        this.tempTickets = this.tempTickets.filter(data => {
          if (this.filterTicketViolation && data.violation){
            return data.violation.toLowerCase().indexOf(this.filterTicketViolation.toLowerCase()) !== -1 || !this.filterTicketViolation.toLowerCase();    
          }else{
            return data.violation;
          }
        });

        this.tempTickets = this.tempTickets.filter(data => { 
          if (data.date && (this.filterTicketDateFrom && this.filterTicketDateTo)){
            return ( new Date(data.date) >= new Date(this.filterTicketDateFrom) && new Date(data.date) <= new Date(this.filterTicketDateTo));   
          }else{
            return data.date;
          };
        });
        
        this.rows = this.tempTickets;
        this.ticketCount = Object.keys(this.tempTickets).length;

        if(this.rows.length>0){
          this.selected = [this.rows[0]]
        }else{
          this.selected = [];
        }
        this.totalTicketAmount = 0;
        this.totalTicket = 0;
        if (this.rows[0]) {
          let sum: number = this.rows.map(a => a.cost).reduce(function(a, b)
          {
          return a + b;
          });
          this.totalTicketAmount = sum;

        this.totalTicket = this.rows.length;
        }
        this.averageTicketAmount = (this.totalTicketAmount / this.totalTicket) || 0;
      }

      case this.prefixIncident :{

        this.tempIncidents = this.fullRowsIncidents.filter(data => {
           if (this.filterIncidentDriver && data.driver_id){
            return data.driver_id ==this.filterIncidentDriver;    
          }else{
            return data.driver_id;
          }
        });

        this.tempIncidents = this.tempIncidents.filter(data => {
          if (this.filterIncidentType && data.type_id){
            return data.type_id == this.filterIncidentType;    
          }else{
            return data.type_id;
          }
        });

        this.tempIncidents = this.tempIncidents.filter(data => { 
          if (data.date_added && (this.filterIncidentDateFrom && this.filterIncidentDateTo)){
            return ( new Date(data.date_added) >= new Date(this.filterIncidentDateFrom) && new Date(data.date_added) <= new Date(this.filterIncidentDateTo));   
          }else{
            return data.date_added;
          };
        });
        
        this.incident_rows = this.tempIncidents;
        this.incidentCount = Object.keys(this.tempIncidents).length;

        if(this.incident_rows.length>0){
          this.selected2 = [this.incident_rows[0]]
        }else{
          this.selected2 = [];
        }
      }

      default: {break;}
    }
  }

  public resetFilters(caller) {
    if (caller== this.prefixIncident){
      this.filterIncidentDriver = '';
      this.filterIncidentDateFrom = null;
      this.filterIncidentDateTo = null;
      this.filterIncidentType = '';

      this.incident_rows = this.fullRowsIncidents;

      if(this.incident_rows.length>0){
        this.selected2 = [this.incident_rows[0]]
      }else{
        this.selected2 = [];
      }
      this.incidentDateRange = [];
      this.getIncidents(this.myDropDown)
    }

    if (caller== this.prefixTicket){

      this.filterTicketDriver = '';
      this.filterTicketDateFrom = null;
      this.filterTicketDateTo = null;
      this.filterTicketViolation = '';
    
      this.rows = this.fullRowsTickets;
      
      if(this.rows.length>0){
        this.selected = [this.rows[0]]
      }else{
        this.selected = [];
      }
      this.ticketDateRange=[];
      this.getTickets(this.myDropDown1);
    }  
    
    this.isFilterEmpty = true;

  }

  markCompleted(objectId, prefix){

    //mark all task completed
    this.spinner = true;
    if(prefix == this.prefixIncident){
      this.taskService.updateAllTaskCompletedByIncidentId(objectId).subscribe(result => {
        this.toastr.success('', result['message'], {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }, ()=>{
        this.toastr.error("Please try again.", "There was a problem with updating the tasks completed by the selected incident entry.", {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      });

      this.getTasksByIncidentId();
      this.getIncidents(this.myDropDown);
    }else{
      if(prefix == this.prefixTicket){
      this.taskService.updateAllTaskCompletedByTrafficTicketId(objectId).subscribe(result => {
        this.toastr.success('', result['message'], {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }, ()=>{
        this.toastr.error("Please try again.", "There was a problem with updating the tasks completed by the selected traffic ticket entry.", {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      });

      this.getTasksByTrafficTicketId();
      this.getTickets(this.myDropDown1);

    }};
    
    this.closeModal();
    this.spinner = false;
  }  

  
  public closeModal(){
    this.modalRef.close();
    this.modalCaller = null;

  }

  public getTasksByIncidentId(){
    if(this.selected2.length >0){
      this.taskService.getTasksByIncidentId(this.selected2[0].id).subscribe(result =>{
        this.tasksByIncidentId = result['tasks'];
      })
    }
  }

  public getTasksByTrafficTicketId(){
    if(this.selected.length >0){
      this.taskService.getTasksByTrafficTicketId(this.selected[0].id).subscribe(result =>{
        this.tasksByTrafficTicketId = result['tasks'];
      })
    }
  }

  openMarkCompleteModal(modalMarkCompleted, prefix): void { 
    this.setCaller(prefix);
    this.modalRef = this.modal.open(modalMarkCompleted, { container: '.app' , size: 'sm', backdrop: 'static'});
  }  

  openPromptModal(modalName, task:Task, prefix) { 
    this.setCaller(prefix);
    this.task = task;
    this.modalRef = this.modal.open(modalName, { container: '.app' , size: 'sm', backdrop: 'static'});
  }  

  markTaskCompleted(taskId : number, prefix){
    this.spinner = true;
    this.taskService.updateTaskCompleted(taskId).subscribe(result => {
      this.toastr.success('', result['message'], {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    }, ()=>{
        this.toastr.error("Please try again.", "There was a problem with updating the selected completed tasks.", {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
    });

    
    if(prefix == this.prefixTicket){
      this.getTasksByTrafficTicketId();
    }else{
      if(prefix == this.prefixIncident){
        this.getTasksByIncidentId();
       }
    };
    
    this.closeModal();
    this.spinner = false;
    this.task = null;
  }

  deleteTask(taskId : number){
    this.spinner = true;
    this.taskService.deleteTask(taskId).subscribe(result => {
      this.toastr.success('', result['message'], {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    }, ()=>{
      this.toastr.error("Please try again.", "There was a problem with deleting the selected task.", {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
  });

    this.closeModalTask(this.caller);
    this.spinner = false;
    this.task = null;
  }
  public action: string;
  openPromptModalTask(modalName, task:Task, objectId, prefix) { 

    this.setCaller(prefix);

    if(task){
      this.action = 'Edit';
    }else{
      this.action = 'Add';  
    };

    this.task = task;
    if (prefix == this.prefixIncident){
      this.incidentId = objectId;
    }else{
      if (prefix == this.prefixTicket){
        this.trafficTicketId = objectId;
      }

    }

    this.modalRef = this.modal.open(modalName, { size: 'lg', backdrop:'static'});
  }  


  public closeModalTask(prefix){
    if(prefix == this.prefixIncident){
      this.getIncidents(this.myDropDown);
      this.getTasksByIncidentId();
    }else{
      if(prefix == this.prefixTicket){
      this.getTickets(this.myDropDown1);
      this.getTasksByTrafficTicketId();}
    }

    this.closeModal();
  }

  public setCaller(caller){
    if(caller == this.prefixIncident){
      this.modalCaller = 'Incident';
      this.caller = this.prefixIncident;
    }else{
      if(caller == this.prefixTicket){
        this.modalCaller = 'Traffic Ticket';
        this.caller = this.prefixTicket;}
        else{this.modalCaller = null};
    }
  }

  getCellClass({ row, column, value }): any {
    return {
      'is-pending': row.status_id == '1',
      'is-completed': row.status_id == '2',
    };
  }

  /*** Export... Module ***/
  //Replaces an attribute name for reading comprehension
  renameKey( obj, oldKey, newKey ) {
    obj[newKey] = obj[oldKey];
    delete obj[oldKey];
  }

  //Formats readable header names in the given table
  incidentRep_generateHeaders(list_incidents): any{
      const arr = JSON.parse(list_incidents);
      arr.forEach( obj => {
        this.renameKey( obj, 'date_added', 'Date' );
        this.renameKey( obj, 'time_added', 'Time' );
        this.renameKey( obj, 'driver', 'Driver' );
        this.renameKey( obj, 'status', 'Status' );
        this.renameKey( obj, 'filename', 'File' );
        
      });
      const updatedJson = JSON.stringify( arr );
      return updatedJson;
  }

  //Filters every column in the table list
  incidentRep_generateColumnsWithFilter(list_incident){
    const arr = JSON.parse(JSON.stringify(list_incident));
    arr.forEach( obj => {

      //Format date
      obj['date_added'] = formatDate(obj['date_added'], 'dd MMM yyyy', 'en_US');

      //remove filtered columns
      if(!this.showIncidentDate){
        delete obj['date_added'];
      };
      if(!this.showIncidentTime){
        delete obj['time_added'];
      };
      if(!this.showIncidentDriver){
        delete obj['driver'];
      };
      if(!this.showIncidentStatus){
        delete obj['status'];
      };
      if(!this.showIncidentFile){
        delete obj['filename'];
      };
      delete obj['id'];
      delete obj['description'];
      delete obj['location'];
      delete obj['status_id'];
      delete obj['rego'];
      delete obj['question_id'];
      delete obj['rating_id'];
      delete obj['witness'];
      delete obj['notification'];
      delete obj['type_id'];
      delete obj['driver_id'];
      delete obj['fleet_id'];
      delete obj['rating'];
      delete obj['type'];
      delete obj['hour'];
      delete obj['minute'];
      delete obj['incidentTaskCount'];
    });
    const updatedJson = JSON.stringify( arr );
    return updatedJson;                         
  }

  //Exports  table to CSV file
  incidentRep_exportToCSV(){
      if(this.incident_rows.length >0){
          let with_header_format, with_column_filter;
          
          //generate json with filtered column
          with_column_filter = this.incidentRep_generateColumnsWithFilter(this.incident_rows);

          //generate json with format header
          this.formatted_list = this.incidentRep_generateHeaders(with_column_filter);

          //export to file
          let current_date = new Date();
          let csv_file = '[TMS]Driver_Incidents_Incident_Reports_' + this.formattedDate(current_date);
          this.exporter.exportToCSV(this.formatted_list, csv_file, 'TMS Driver Incidents - Incident Reports');
      }
  };

  //Exports table to PDF file
  incidentRep_exportToPDF(){
    if(this.incident_rows.length >0){
      let with_header_format, with_column_filter;

      //generate json with filtered column
      with_column_filter = this.incidentRep_generateColumnsWithFilter(this.incident_rows);

      //generate json with format header
      this.formatted_list = this.incidentRep_generateHeaders(with_column_filter);

      //export to file
      let current_date = new Date();
      let pdf_file = '[TMS]Driver_Incidents_Incident_Reports_' + this.formattedDate(current_date);
      this.exp_pdf.title = 'INCIDENT REPORTS';
      this.exp_pdf.type = 'pdf';
      this.exp_pdf.list_data = this.formatted_list;
      this.exporter.exportToPDF(this.exp_pdf).subscribe(data=>{
        saveAs(data, pdf_file + '.' + this.exp_pdf.type);
      });
    }
  };

  //Exports table to MS Excel file
  incidentRep_exportToExcel(){
      if(this.incident_rows.length >0){
          let with_header_format, with_column_filter;
          
          //generate json with filtered column
          with_column_filter = this.incidentRep_generateColumnsWithFilter(this.incident_rows);

          //generate json with format header
          this.formatted_list = this.incidentRep_generateHeaders(with_column_filter);

          //export to file
          let current_date = new Date();
          let excel_file = '[TMS]Driver_Incidents_Incident_Reports_' + this.formattedDate(current_date);
          this.exp_excel.title = 'INCIDENT REPORTS';
          this.exp_excel.type = 'xlsx';
          this.exp_excel.list_data = this.formatted_list;
          this.exporter.exportToExcel(this.exp_excel).subscribe(data=>{
              saveAs(data, excel_file)
          });
      }
  };

   //Formats readable header names in the given table
   trafficTicket_generateHeaders(list_incidents): any{
    const arr = JSON.parse(list_incidents);
    arr.forEach( obj => {
      this.renameKey( obj, 'date', 'Date' );
      this.renameKey( obj, 'time', 'Time' );
      this.renameKey( obj, 'driver', 'Driver' );
      this.renameKey( obj, 'status', 'Status' );
      this.renameKey( obj, 'file', 'File' );
      
    });
    const updatedJson = JSON.stringify( arr );
    return updatedJson;
  }

  //Filters every column in the table list
  trafficTicket_generateColumnsWithFilter(list_ticket){
      const arr = JSON.parse(JSON.stringify(list_ticket));
      arr.forEach( obj => {

		  obj['date'] = formatDate(obj['date'], 'dd MMM yyyy', 'en_US');

        //remove filtered columns
        if(!this.showTicketDate){
          delete obj['date'];
        };
        if(!this.showTicketTime){
          delete obj['time'];
        };
        if(!this.showTicketDriver){
          delete obj['driver'];
        };
        if(!this.showTicketStatus){
          delete obj['status'];
        };
        if(!this.showTicketFile){
          delete obj['file'];
        };
        delete obj['id'];
        delete obj['rego'];
        delete obj['violation'];
        delete obj['driver_no'];
        delete obj['cost'];
        delete obj['demerits'];
        delete obj['receipt_no'];
        delete obj['note'];
        delete obj['status_id'];
        delete obj['hour'];
        delete obj['minute'];
        delete obj['fleet_id'];
        delete obj['ticketTaskCount'];
        delete obj['location'];
      });
      const updatedJson = JSON.stringify( arr );
      return updatedJson;                         
  }

  //Exports  table to CSV file
  trafficTicket_exportToCSV(){
      if(this.rows.length >0){
          let with_header_format, with_column_filter;
          
          //generate json with filtered column
          with_column_filter = this.trafficTicket_generateColumnsWithFilter(this.rows);

          //generate json with format header
          this.formatted_list = this.trafficTicket_generateHeaders(with_column_filter);

          //export to file
          let current_date = new Date();
          let csv_file = '[TMS]Driver_Incidents_Traffic_Tickets_' + this.formattedDate(current_date);
          this.exporter.exportToCSV(this.formatted_list, csv_file, 'TMS Driver Incidents - Traffic Tickets');
      }
  };

  //Exports table to PDF file
  trafficTicket_exportToPDF(){
    if(this.rows.length >0){
      let with_header_format, with_column_filter;

      //generate json with filtered column
      with_column_filter = this.trafficTicket_generateColumnsWithFilter(this.rows);

      //generate json with format header
      this.formatted_list = this.trafficTicket_generateHeaders(with_column_filter);

      //export to file
      let current_date = new Date();
      let pdf_file = '[TMS]Driver_Incidents_Traffic_Tickets_' + this.formattedDate(current_date);
      this.exp_pdf.title = 'TRAFFIC TICKETS';
      this.exp_pdf.type = 'pdf';
      this.exp_pdf.list_data = this.formatted_list;
      this.exporter.exportToPDF(this.exp_pdf).subscribe(data=>{
        saveAs(data, pdf_file + '.' + this.exp_pdf.type);
      });
    }
  };

  //Exports table to MS Excel file
  trafficTicket_exportToExcel(){
      if(this.rows.length >0){
          let with_header_format, with_column_filter;
          
          //generate json with filtered column
          with_column_filter = this.trafficTicket_generateColumnsWithFilter(this.rows);

          //generate json with format header
          this.formatted_list = this.trafficTicket_generateHeaders(with_column_filter);

          //export to file
          let current_date = new Date();
          let excel_file = '[TMS]Driver_Incidents_Traffic_Tickets_' + this.formattedDate(current_date);
          this.exp_excel.title = 'TRAFFIC TICKETS';
          this.exp_excel.type = 'xlsx';
          this.exp_excel.list_data = this.formatted_list;
          this.exporter.exportToExcel(this.exp_excel).subscribe(data=>{
             
              saveAs(data, excel_file)

          });
      }
  }; 

    //Returns a date format in the file name
    public formattedDate(d = new Date) {
      let month = String(d.getMonth() + 1);
      let day = String(d.getDate());
      const year = String(d.getFullYear());
    
      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
    
      return `${day}/${month}/${year}`;
    }

    public getImages(event){
      
      this.imageFiles = event;
        for (let i =0; i < this.imageFiles.length;i++){
            if ( i == 0){
            this.incidentFormMobile.controls.file1.setValue(this.imageFiles[0].dataUrl);
            }
            else if ( i == 1){
              this.incidentFormMobile.controls.file2.setValue(this.imageFiles[1].dataUrl);
            }
           else if ( i == 2){
              this.incidentFormMobile.controls.file3.setValue(this.imageFiles[2].dataUrl);
            }
           else if ( i ==3){
              this.incidentFormMobile.controls.file4.setValue(this.imageFiles[3].dataUrl);
            }
           else if ( i == 4){
               this.incidentFormMobile.controls.file5.setValue(this.imageFiles[4].dataUrl);
            }
           else if ( i == 5){
               this.incidentFormMobile.controls.file6.setValue(this.imageFiles[5].dataUrl);
            }
           else if ( i == 6){
               this.incidentFormMobile.controls.file7.setValue(this.imageFiles[6].dataUrl);
            }
           else if ( i == 7){
                this.incidentFormMobile.controls.file8.setValue(this.imageFiles[7].dataUrl);
            }
          else  if ( i == 8){
               this.incidentFormMobile.controls.file9.setValue(this.imageFiles[8].dataUrl);
            }
           else if ( i == 9){
            this.incidentFormMobile.controls.file10.setValue(this.imageFiles[9].dataUrl);
            }
        }
      
      this.incidentFormMobile.controls.fileCount.setValue(this.imageFiles.length);
      
    }
    
  }